import * as React from "react";
import { Wrap } from "../Layout/Page";
import ProjectsBox from "./components/ProjectsBox";
import SettingsBox from "./components/SettingsBox";
import {
  ContentWrapper,
  Frame,
  RulesBoxWrapper as BoxWrapper,
  BoxHeader,
  BoxHeading,
} from "./ProjectSettings.styles";
import Foot from "./components/Foot";
import RulesBox from "./components/RulesBox";
import { useRulesState } from "../../context/settings/rules";
import { useProjectSettings } from "./hooks/useProjectSettings";
import { SavingOverlay } from "./components/SavingOverlay";

interface OwnProps {
  sites: Insite.AppState["userSites"]["sites"];
  siteList: Insite.AppState["userSites"]["sites"][];
  projectList: Insite.Project[];
  onSave(): void;
}

export const ProjectSettings: React.FC<OwnProps> = (props) => {
  const { projectList, onSave } = props;
  const { ruleList } = useRulesState();
  const {
    handleProjectSelect,
    handleRuleSelect,
    selectedRule,
    activeProject,
    isSaving,
  } = useProjectSettings(projectList);

  React.useEffect(() => {
    if (isSaving) {
      onSave();
    }
  }, [isSaving]);

  return (
    <Wrap>
      <Frame>
        <ContentWrapper>
          {isSaving && <SavingOverlay />}
          <ProjectsBox
            projectList={projectList}
            onProjectSelect={handleProjectSelect}
            activeProject={activeProject}
          />
          <BoxWrapper>
            <BoxHeader>
              <BoxHeading>Insights</BoxHeading>
            </BoxHeader>
            {ruleList && ruleList.length > 0 && (
              <RulesBox
                ruleList={ruleList}
                selectedRule={selectedRule}
                onRuleSelect={handleRuleSelect}
                activeProject={activeProject}
              />
            )}
          </BoxWrapper>
          <SettingsBox selectedRule={selectedRule} />
        </ContentWrapper>
        <Foot activeProject={activeProject} />
      </Frame>
    </Wrap>
  );
};
